import { LocationType } from "./Enums";

export class CopyDispatchParameters {
	locCode: string = '';
	locationType: LocationType = LocationType.Origin;
	planPeriod: string = '';
	periodStartDate: string = '';
	periodEndDate: string = '';
	dispatchId: number = 0;
	truckerId: number = 0;
	scheduleId: number = 0;
	scheduleExists: boolean = false;
	stagingExists: boolean = false;
	scheduleDispatchCount: number = 0;
	isConfirmed: boolean = false;
	saveError: boolean = false;
}